import { CreateInstance } from "./config"

// MDM API — prefix: /lmm/api/v1.0/mdm/*  (ST3 전용 백엔드)
export const MdmProfileAPI = CreateInstance("mdm/policy-profiles") // 기기정책(구성) CRUD·복사·매트릭스·준수
export const MdmAppAPI = CreateInstance("mdm/applications") // 앱 업로드·목록·삭제
export const MdmCompanywideAPI = CreateInstance("mdm/companywide-profiles") // "모든 구성" 전체적용
export const MdmAssignAPI = CreateInstance("mdm/device-assignments") // 기기 할당
